/**
 * @file Popup Alert.
 */

/**
 * Popup Alert component.
 */
const vPopupAlert = () => {
	const popupAlert = document.querySelector('.v-popup-alert');

	if (!popupAlert) return;

	const closePopUp = popupAlert.querySelector('.v-popup-alert__close-btn');
	const popUpOverlay = popupAlert.querySelector('.v-popup-alert__overlay');
	const dismissButton = popupAlert.querySelector('.v-popup-alert__btn');
	// const modalID = '2837365';
	const modalID = popupAlert.getAttribute('data-id');
	// const resetFlagID = '';
	const resetFlagID = `${modalID}-reset`;

	/**
	 * Show popup.
	 */
	function showPopup() {
		const { body } = document;
		const wasDismissed = localStorage.getItem(modalID);
		body.style.overflow = 'hidden';

		if (wasDismissed === 'dismissed') {
			body.style.overflow = 'auto';
			return;
		}

		popupAlert.classList.remove('v-popup-alert--hide');
		localStorage.setItem(modalID, 'seen');
	}
	showPopup();

	/**
	 * Close popup.
	 */
	function closePopup() {
		const { body } = document;
		body.style.overflow = 'auto';
		popupAlert.classList.add('v-popup-alert--close');
		popupAlert
			.querySelector('.v-popup-alert__container')
			.classList.add('v-popup-alert__container--hide');

		localStorage.setItem(modalID, 'dismissed');
	}

	/**
	 * Reset popup.
	 */
	function resetPopup() {
		localStorage.removeItem(modalID);
		localStorage.setItem(resetFlagID, 'true');
		showPopup();
	}

	if (closePopUp) {
		closePopUp.addEventListener('click', () => {
			closePopup();
		});
	}

	if (popUpOverlay) {
		popUpOverlay.addEventListener('click', () => {
			closePopup();
		});
	}

	if (dismissButton) {
		dismissButton.addEventListener('click', () => {
			closePopup();
		});
	}

	document.addEventListener('keyup', (e) => {
		if (e.key === 'Escape') {
			closePopup();
		}
	});

	// Reset the popup for all users only once
	if (!localStorage.getItem(resetFlagID)) {
		resetPopup();
	}

	// Expose resetPopup to be callable from outside
	window.resetPopupAlert = resetPopup;
};

export default vPopupAlert;
